import { ROUTE_DATA_CACHE_KEY } from "../utils/LocalStoragekeys";
import { fetchRouteInformation } from "../network/RouteNetworkAPI";
import { setDataWithExpiry } from "../../outboundAmzl/util/CacheManager";
import {
  LOAD_VIEW,
  UNLOAD_VIEW,
  RECEIVE_DATA,
  UPDATE_ROUTE_DATA_CACHE,
  SHOW_NOTIFICATION,
  REMOVE_NOTIFICATION,
} from "../utils/ReducerActionTypes";

export const RouteStatusReducer = (state, action) => {
  switch (action.type) {
    case LOAD_VIEW: {
      fetchRouteInformation(action.data);
      return state;
    }
    case UNLOAD_VIEW:
      return state;
    case RECEIVE_DATA:
      return { ...state, ...action.data };
    case UPDATE_ROUTE_DATA_CACHE: {
      setDataWithExpiry(ROUTE_DATA_CACHE_KEY, action.data, action.lastUpdated);
      return state;
    }
    case SHOW_NOTIFICATION:
      return { ...state, ...action.data };
    case REMOVE_NOTIFICATION:
      const notification = { alert: {} };
      return { ...state, ...notification };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/components/RouteStatus/reducers/RouteStatusReducer.js